import { css } from 'styled-components'

export const Nanum_eb_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 800;
  line-height: 1.2;
  font-family: 'NanumSquareEB', sans-serif;
`
export const Nanum_b_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 700;
  line-height: 1.2;
  font-family: 'NanumSquareB', sans-serif;
`
export const Nanum_r_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 400;
  line-height: 1.2;
  font-family: 'NanumSquareR', sans-serif;
`
export const Nanum_rb_size = (size: number) => css`
  font-size: ${size}px;
  font-weight: 700;
  line-height: 1.2;
  font-family: 'NanumSquareR', sans-serif;
`
